import { Button, Col, Form, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React from 'react'

import { GrAttachment } from "react-icons/gr";

function CommentBox() {
  return (
    <div className='comment-box'>
      <Row gutter={[12, 0]}>
        <Col span={1}>
            <div className='avatar-container'><span>s</span></div>
        </Col>
        <Col span={23}>
            <Form.Item>
                <TextArea placeholder='Write a comment' rows={8} />
            </Form.Item>
        </Col>
      </Row>
      <Row justify="end" gutter={[8, 0]}>
        <Col><Button><GrAttachment /></Button></Col>
        <Col><Button type='primary'>Send</Button></Col>
      </Row>
    </div>
  )
}

export default CommentBox;
